const selectDataState = (state) => (state && state.data) || {};

export { selectDataState };
